import React from "react";
import { useQuery } from "@apollo/client";

import { GET_DYNAMIC_PAGE_BY_ADMIN_ID_PARAMS } from "../graphql";
import { LoadingIndicator } from "../LoadingIndicator";
import { DynamicPageEntity, getDynamicPageFromGQResult, GraphQLResponse } from "../processors";
import { GraphicElementWithNid } from "../GraphicElement";

export interface DynamicPageProps {
    adminId: string;
}

export const DynamicPage: React.FC<DynamicPageProps> = ({ adminId }) => {
    const { query, options } = GET_DYNAMIC_PAGE_BY_ADMIN_ID_PARAMS(adminId);
    const { loading, data } = useQuery<GraphQLResponse<DynamicPageEntity>>(query, options);

    const page = getDynamicPageFromGQResult([data?.result]?.filter(d => d != null))?.[0];

    const { className, graphicElements } = page ?? {};

    return (
        <div className={`row ${className ?? ""}`}>
            {loading && (
                <div className="col-12">
                    <LoadingIndicator />
                </div>
            )}

            {(graphicElements ?? []).map(({ nid }, index) => {
                return (
                    <GraphicElementWithNid
                        nid={nid}
                        // key={nid}
                        key={index}
                    />
                );
            })}
        </div>
    );
};
